import { NavLink } from '../Link';
import { NavDropdown } from '../Dropdown';

import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../common/hooks';

const Title = styled('h2')(({ theme }) => ({
    all: 'unset',
    fontFamily: 'TT Commons Pro Condensed',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    letterSpacing: '0.02em',
    color: theme.palette.semantic.text.default,
    marginBottom: '4px'
}));

const SubTitle = styled('p')(({ theme }) => ({
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.semantic.text.muted,
    marginBottom: '14px'
}));

const Link = styled('a')(({ theme }) => ({
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    marginRight: 'auto',
    color: theme.palette.semantic.int.link,
    cursor: 'pointer'
}));

type Props = {
    isDropdownActive: boolean;
    onToggleDropdown(): void;
};

export const NavContact = ({ isDropdownActive, onToggleDropdown }: Props) => {
    const { t } = useTranslation();
    const supportEmail = useAppSelector(
        (state) => state.global?.globalConfig?.supportEmail || t('APPLICATION_SUPPORT_EMAIL')
    );

    return (
        <>
            <NavLink onClick={onToggleDropdown} id="nav-contact-button" aria-expanded={isDropdownActive}>
                {t('CONTACT_US_TEXT')}
            </NavLink>

            <NavDropdown isVisible={isDropdownActive} parentId="nav-contact-button" onClose={onToggleDropdown}>
                <Title>{t('CONTACT_US_TEXT')}</Title>
                <SubTitle>{t('BY_EMAIL_TEXT')}</SubTitle>
                <Link href={`mailto:${supportEmail}`}>{supportEmail}</Link>
            </NavDropdown>
        </>
    );
};
